import React, { useState, useEffect, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './CreatorBenefits.css';

const benefits = [
  {
    title: "NO BS - JUST EYES ON YOUR WORK",
    description: "RawOra puts your art in front of the people who actually care. No begging, no dancing for the algorithm. Just your work, seen and celebrated."
  },
  {
    title: "ART FOR SALE (INTEGRITY NOT INCLUDED)",
    description: "Just kidding - you keep that part. Sell your work. Stack tips, not just emoji reactions. Build your creative empire without selling out to the suits."
  },
  {
    title: "CREATE WITHOUT CENSORSHIP",
    description: `No "community guidelines" stopping your expression. No corporate filters watering you down. Just raw, unfiltered, whatever-the-hell-you-want creativity.`
  },
  {
    title: "FIND COLLABORATORS, NOT JUST FOLLOWERS",
    description: "Network without the cringe. Meet fellow creatives, industry pros, and future collaborators who actually get what you do. No tedious networking events required."
  }
];

const CreatorBenefits = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  const handleTitleClick = useCallback((index) => {
    setActiveIndex(index);
    setIsAutoPlaying(false); // Pause auto-rotation when user clicks
  }, []);

  useEffect(() => {
    if (!isAutoPlaying) return;

    const timer = setInterval(() => {
      setActiveIndex((current) => (current + 1) % benefits.length);
    }, 10000); // Change every 10 seconds

    return () => clearInterval(timer);
  }, [isAutoPlaying]);

  // Resume auto-rotation after 20 seconds of inactivity
  useEffect(() => {
    if (!isAutoPlaying) {
      const resumeTimer = setTimeout(() => {
        setIsAutoPlaying(true);
      }, 20000);

      return () => clearTimeout(resumeTimer);
    }
  }, [isAutoPlaying]);

  return (
    <div className="creator-benefits">
      <h2>FOR CREATORS</h2>
      <div className="benefits-container">
        {benefits.map((benefit, index) => (
          <div 
            key={index} 
            className={`benefit-item ${index === activeIndex ? 'active' : ''}`}
          >
            <div className="benefit-content">
              <h3 
                onClick={() => handleTitleClick(index)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    handleTitleClick(index);
                  }
                }}
                tabIndex={0}
                role="button"
                aria-expanded={index === activeIndex}
                aria-controls={`description-${index}`}
              >
                {benefit.title}
              </h3>
              <AnimatePresence mode="wait">
                {index === activeIndex && benefit.description && (
                  <motion.div
                    id={`description-${index}`}
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.5, ease: "easeInOut" }}
                    className="description-container"
                  >
                    <p>{benefit.description}</p>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
            <div className="highlight-bar" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default CreatorBenefits; 